import styled from "@emotion/styled";
import React, { useMemo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import contractTemplate from "../../data/contractTemplate";

const StyledDiv = styled.div`
  max-height: 70vh;
  width: 600px;
  margin: 1.2rem;
  overflow-x: hidden;
  overflow-y: scroll;
  padding: 20px;
  background-color: #d9d9d9;
  /* border: 2px solid brown; */

  .contract {
    background-color: white;
    padding: 1.2rem;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

    h2,
    h3,
    h1 {
      /* border: 2px solid pink; */
      margin-left: auto;
      margin-right: auto;
      width: fit-content;
      margin-bottom: 1.2rem;
    }

    h4 {
      width: fit-content;
      margin: auto;
      font-weight: 500;
    }

    h5 {
      border-bottom: 1px solid black;
      width: 60%;
      margin: auto;
      margin-top: 3rem;
      margin-bottom: 2rem;
    }

    a {
      text-decoration: none;
      color: black;
    }

    table {
      width: 95%;
      margin-right: auto;
      margin-left: auto;

      border-spacing: 0;

      td {
        border: 1px solid black;
        margin: none;
        padding: 0.8rem;
      }
    }
  }

  @media (max-width: 768px) {
    width: 70vw;
  }
`;

export interface ContractProps {
  fullName: string;
  cpf: string;
  address: string;
  email: string;
  phoneNumber: string;
  marritalStatus: string;
  associateQuantity: string;
  membershipPrice: string;
  pricePerAssociate: string;
  startDate: string;
  renewalDate: string;
  priceReadjustment: string;
  birthDate: string;
}

const Contract: React.FC<ContractProps> = (props) => {
  const handleKeywords = (body: string) => {
    return body
      .replaceAll("{{fullName}}", props.fullName)
      .replaceAll("{{fullNameUppercase}}", props.fullName.toUpperCase())
      .replaceAll("{{cpf}}", props.cpf)
      .replaceAll("{{address}}", props.address)
      .replaceAll("{{email}}", props.email)
      .replaceAll("{{phoneNumber}}", props.phoneNumber)
      .replaceAll("{{marritalStatus}}", props.marritalStatus)
      .replaceAll("{{associateQuantity}}", props.associateQuantity)
      .replaceAll("{{membershipPrice}}", props.membershipPrice)
      .replaceAll("{{pricePerAssociate}}", props.pricePerAssociate)
      .replaceAll("{{startDate}}", props.startDate)
      .replaceAll("{{renewalDate}}", props.renewalDate)
      .replaceAll("{{priceReadjustment}}", props.priceReadjustment)
      .replaceAll("{{birthDate}}", props.birthDate);
  };

  const contractBody = useMemo(() => {
    return handleKeywords(contractTemplate);
  }, [props]);

  return (
    <StyledDiv>
      <ReactMarkdown
        className="contract"
        children={contractBody}
        remarkPlugins={[remarkGfm]}
      />
    </StyledDiv>
  );
};

export default Contract;
